import { CircuitBoard, Factory, Leaf, Rocket } from "lucide-react"
import "./AboutSection.css"
import { Link } from "react-router-dom"
const AboutSection = () => {
  const solutions = [
    {
      icon: <CircuitBoard size={32} />,
      title: "Electrified Mobility",
      description: "Pioneering thermal management and power transmission solutions for next-generation electric vehicles and hybrid systems."
    },
    {
      icon: <Factory size={32} />,
      title: "Industrial Applications",
      description: "High-performance fluid systems for manufacturing, robotics, and heavy equipment operations across industries."
    },
    {
      icon: <Leaf size={32} />,
      title: "Sustainable Solutions",
      description: "Eco-friendly transmission technologies that reduce environmental impact while maintaining peak performance."
    },
    {
      icon: <Rocket size={32} />,
      title: "Advanced Engineering",
      description: "Cutting-edge R&D developing tomorrow's transmission technologies today."
    }
  ]

  return (

    <section className="about-section">
      <div className="container">
        <div className="section-header">
          <span className="section-subtitle">Innovation in Motion</span>
          <h2 className="section-title">Redefining Fluid Transmission</h2>
          <p className="section-intro">
            At the forefront of fluid dynamics engineering, we deliver precision solutions
            that power industries and propel innovation forward.
          </p>
        </div>

        <div className="solutions-grid">
          {solutions.map((solution, index) => {
            const solutionSlug = solution.title.toLowerCase().replace(/\s+/g, '-');
            return (
              <Link key={index}  to="/hoses" className={`solution-card ${solutionSlug}`}>
                <div className="solution-icon-container">
                  {solution.icon}
                </div>
                <h3>{solution.title}</h3>
                <p>{solution.description}</p>
              </Link>
            )
          })}
        </div>

        {/* <div className="about-content">
          <div className="about-text">
            <h3>Engineering Excellence Since 1995</h3>
            <p>
              With three decades of specialized expertise, we've established ourselves as 
              global leaders in fluid transmission technology. Our solutions power 
              everything from urban mobility to space exploration applications.
            </p>
            <p>
              What sets us apart is our commitment to pushing boundaries - we've developed 
              over 200 proprietary technologies and hold 47 international patents in 
              fluid dynamics and transmission systems.
            </p>
            <button className="cta-button">
              Explore Our Technology
              <span className="arrow-icon">→</span>
            </button>
          </div>
          <div className="stats-container">
            <div className="stat-item">
              <span className="stat-number">30+</span>
              <span className="stat-label">Years Experience</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">47</span>
              <span className="stat-label">Patents</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">200+</span>
              <span className="stat-label">Proprietary Technologies</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">60+</span>
              <span className="stat-label">Countries Served</span>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  )
}

export default AboutSection